import Grid from '@material-ui/core/Grid';
import GridOnIcon from '@material-ui/icons/GridOn';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS } from '../../application-core/constants';
import InAppBar from '../../core/InAppBar';
import { processHashLocation } from '../../core/utils/utils';
import Warning from '../../core/Warning';
import GS from '../../grafsync/grafsync';
import ResourceView from '../ResourceView';

class FloatingDataEditorContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      updateAt: null,
      viewLang: props.defaultLang,
      deletedResources: [],
      activeResource: null,
      isErrored: false
    };
  }

  static getDerivedStateFromProps(props, state) {
    const paramsMap = processHashLocation(props.location);
    const resource = paramsMap.get("resource");
    if (resource !== state.activeResource) {
      return {
        ...(state.activeResource !== resource) &&
        { activeResource: (resource === undefined || resource === null || resource === "") ? null : resource }
      };
    }
    return null;
  }

  buildLink(resource) {
    let link = APPLICATION_PATHS.DATA_MANAGER + '/project/floating#project=' + this.props.project;
    link += resource !== null ? "&resource=" + resource : "";
    return link;
  }

  onExitWarning = () => this.setState({ isErrored: false });

  componentDidMount() {
    if (this.state.activeResource) this.setFoundResource(this.state.activeResource);
  }

  setFoundResource = async (iri) => {
    this.showIsolatedDetail(iri);
  };

  showIsolatedDetail = (iri) => {
    const link = this.buildLink(iri);
    const currentPath = this.props.location.pathname + this.props.location.hash;
    if (currentPath !== link) this.props.history.push(link);
  };

  deleteResource = (iri) => {
    GS.deleteResource(iri, this.props.graph);
    const deletedResourcesList = [...this.state.deletedResources];
    deletedResourcesList.push(iri);
    this.setState({
      updateAt: Date.now(),
      deletedResources: deletedResourcesList
    });
    this.showIsolatedDetail(null);
  };

  setViewLanguage = (lang) => {
    // To avoid API overloading we wait until any outstanding requests have completed before changing language
    const inFlight = GS.isLoadingInFlight();
    if (inFlight) {
      if (this.langTimeout) clearTimeout(this.langTimeout);
      this.langTimeout = setTimeout(() => this.setViewLanguage(lang), 250);
    }
    else {
      this.setState({ viewLang: lang });
    }
  };

  render() {

    const { deletedResources, tabValue, isErrored, activeResource, message, viewLang } = this.state;
    const { defaultLang, project, graph, entitlements } = this.props;

    if (isErrored) return <Warning message={message} onExitWarning={this.onExitWarning} />;

    let tabItems = [{
      icon: GridOnIcon,
      label: "Resources"
    }];

    const appBar = <InAppBar
      tabValue={tabValue}
      onChangeTab={this.changeTab}
      tabItems={tabItems} />;

    return (
      <Grid container spacing={0}>
        <Grid item xs={12}>
          {tabValue === 0 &&
            <ResourceView
              appBar={appBar}
              entitlements={entitlements}
              graph={graph}
              isReadOnly={true}
              project={project}
              activeResource={activeResource}
              defaultLang={defaultLang}
              viewLang={viewLang}
              onSelect={this.showIsolatedDetail}
              onSelectViewLanguage={this.setViewLanguage}
              deletedResources={deletedResources}
              onDeleteResource={this.deleteResource}
            />
          }
        </Grid>
      </Grid>
    );
  }

}

FloatingDataEditorContainer.propTypes = {
  entitlements: PropTypes.array.isRequired,
  history: PropTypes.object,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(FloatingDataEditorContainer);